import React from 'react'
import type { StartLabelFieldsContainerProps } from '@edge/spark/feature-mui-rhf-inputs'
import { StartLabelFieldsContainer } from '@edge/spark/feature-mui-rhf-inputs'

export const Container: React.VFC<StartLabelFieldsContainerProps> = ({
    children,
    ...props
}: StartLabelFieldsContainerProps) => (
    <StartLabelFieldsContainer labelColon {...props}>
        {children}
    </StartLabelFieldsContainer>
)
